import * as types from './mutations-type'

const actions = {
  addGlobalLayer ({ commit, state }, layer) {
    commit(types.SET_GLOBAL_LAYERS, [].concat(state.globalLayers, [layer]))
  },
  removeGlobalLayer ({ commit, state }, layerName) {
    const rest = state.globalLayers.filter(item => item.name !== layerName)
    commit(types.SET_GLOBAL_LAYERS, rest)
  },
  clearGlobalLayers ({ commit }) {
    commit(types.SET_GLOBAL_LAYERS, [])
  }
}

export default actions
